/* HTML Example:
<div data-controller="copy-to-clipboard">
  <i class="bi bi-copy cursor-pointer"
              title="Copy"
              data-bs-toggle="tooltip"
              data-copy-to-clipboard-target="icon"
              data-copy-to-clipboard-value="Value to copy"
              data-action="click->copy-to-clipboard#copy"></i>
  <i class="bi bi-check-circle-fill text-success d-none" data-copy-to-clipboard-target="checkmark"></i>
</div>
*/

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['icon', 'checkmark']

  copy(event) {
    event.preventDefault()

    const phoneNumber = this.iconTarget.getAttribute(
      'data-copy-to-clipboard-value'
    )

    navigator.clipboard.writeText(phoneNumber).then(() => {
      // A focused button that hides drops focus to the page; the checkmark holds it until the button is back.
      const focused = this.iconTarget.contains(document.activeElement)
      this.iconTarget.classList.add('d-none')
      this.checkmarkTarget.classList.remove('d-none')
      if (focused) {
        this.checkmarkTarget.tabIndex = -1
        this.checkmarkTarget.focus()
      }

      setTimeout(() => {
        const held = this.checkmarkTarget.contains(document.activeElement)
        this.iconTarget.classList.remove('d-none')
        this.checkmarkTarget.classList.add('d-none')
        if (held) this.iconTarget.focus()
      }, 2000)
    })
  }
}
